export const Validations = {
    /*
	------------------------------------------------------------------------
	Validate whole steps at a time and mix and match the fields that need
	to be validated as needed.
	------------------------------------------------------------------------
	*/

    //
    // Validate the Start step.
    //
    validateStart(store) {
        // $log.log(`validateStart()`);
        const result = this.validateFirstName(store) && this.validateLastName(store) && this.validateCompany(store) && this.validateEmail(store);
        // $log.log(`result : ${JSON.stringify(result, null, 4)}`);
        store.validation.Start.valid = result;
        return result;
    },

    //
    // Validate the Project step.
    //
    validateProject(store) {
        const result = this.validateProjectName(store) && this.validateRoomName(store);
        store.validation.Project.valid = result;
        return result;
    },

    //
    // Validate the Room step.
    //
    validateRoom(store) {
        const result =
            this.validateRoomWidth(store) &&
            this.validateRoomLength(store) &&
            this.validateRoomHeight(store) &&
            this.validateRoomMaterials(store) &&
            this.validateRoomUsage(store);
        store.validation.Room.valid = result;
        return result;
    },

    //
    // Validate the Product step.
    // Checks: product selected, shape selected (if applicable), size selected, variant selected (if applicable), lumen output selected (if applicable)
    //
    validateProduct(store) {
        const result =
            this.validateProductSelected(store) &&
            this.validateProductShape(store) &&
            this.validateProductSize(store) &&
            this.validateProductLumenOutput(store);
        store.validation.Product.valid = result;
        return result;
    },
    /*
	------------------------------------------------------------------------
	Validate individual fields.

    These can be built up to validate as many conditions as needed for any
    particular field. e.g., eail needs to have a value and also needs to
    validate to the email format.
	------------------------------------------------------------------------
	*/

    //
    // Validate the first name field.
    //
    validateFirstName(store) {
        let valid = store.user.firstname !== '';
        if (!valid) {
            store.validation.Start.errors.firstname = 'Please provide your first name.';
        } else {
            store.validation.Start.errors.firstname = '';
        }
        return valid;
    },

    //
    // Validate the last name field.
    //
    validateLastName(store) {
        let valid = store.user.lastname !== '';
        if (!valid) {
            store.validation.Start.errors.lastname = 'Please provide your last name.';
        } else {
            store.validation.Start.errors.lastname = '';
        }
        return valid;
    },

    //
    // Validate the company field.
    //
    validateCompany(store) {
        let valid = store.user.company !== '';
        if (!valid) {
            store.validation.Start.errors.company = 'Please provide your company name.';
        } else {
            store.validation.Start.errors.company = '';
        }
        return valid;
    },

    //
    // Validate the email field.
    //
    validateEmail(store) {
        let valid = store.user.email !== '';
        if (!valid) {
            store.validation.Start.errors.email = 'Please provide your company email.';
        } else {
            const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            valid = pattern.test(store.user.email);
            // $log.log(`valid : ${JSON.stringify(valid, null, 4)}`);
            if (!valid) {
                store.validation.Start.errors.email = 'Please provide a valid company email address.';
            } else {
                store.validation.Start.errors.email = '';
            }
        }
        return valid;
    },

    //
    // Validate the project name field
    //
    validateProjectName(store) {
        let valid = store.user.projectname !== '';
        if (!valid) {
            store.validation.Project.errors.projectname = 'Please provide your project name.';
        } else {
            store.validation.Project.errors.projectname = '';
        }
        return valid;
    },

    //
    // Validate the room name field
    //
    validateRoomName(store) {
        let valid = store.user.roomname !== '';
        if (!valid) {
            store.validation.Project.errors.roomname = 'Please provide your room name.';
        } else {
            store.validation.Project.errors.roomname = '';
        }
        return valid;
    },

    //
    // Validate the room width field
    //
    validateRoomWidth(store) {
        // Return false (invalid) if room is null/undefined to prevent errors
        if (!store.user.room) {
            store.validation.Room.errors.roomwidth = 'Please enter the room width.';
            return false;
        }
        let valid = store.user.room.width !== '' && store.user.room.width !== 0;
        if (!valid) {
            store.validation.Room.errors.roomwidth = 'Please enter the room width.';
        } else {
            if (store.user.room.unit === 'imperial') {
                valid = store.user.room.width <= 150;
                if (!valid) {
                    store.validation.Room.errors.roomwidth = 'Please enter a room width of no more than 150ft.';
                } else {
                    store.validation.Room.errors.roomwidth = '';
                }
            }
            if (store.user.room.unit === 'metric') {
                valid = store.user.room.width <= 50;
                if (!valid) {
                    store.validation.Room.errors.roomwidth = 'Please enter a room width of no more than 50mt.';
                } else {
                    store.validation.Room.errors.roomwidth = '';
                }
            }
        }
        return valid;
    },

    //
    // Validate the room length field
    //
    validateRoomLength(store) {
        // Return false (invalid) if room is null/undefined to prevent errors
        if (!store.user.room) {
            store.validation.Room.errors.roomlength = 'Please enter the room length.';
            return false;
        }
        let valid = store.user.room.length !== '' && store.user.room.length !== 0;
        if (!valid) {
            store.validation.Room.errors.roomlength = 'Please enter the room length.';
        } else {
            if (store.user.room.unit === 'imperial') {
                valid = store.user.room.length <= 150;
                if (!valid) {
                    store.validation.Room.errors.roomlength = 'Please enter a room length of no more than 150ft.';
                } else {
                    store.validation.Room.errors.roomlength = '';
                }
            }
            if (store.user.room.unit === 'metric') {
                valid = store.user.room.length <= 50;
                if (!valid) {
                    store.validation.Room.errors.roomlength = 'Please enter a room length of no more than 50mt.';
                } else {
                    store.validation.Room.errors.roomlength = '';
                }
            }
        }
        return valid;
    },

    //
    // Validate the room height field
    //
    validateRoomHeight(store) {
        // Return false (invalid) if room is null/undefined to prevent errors
        if (!store.user.room) {
            store.validation.Room.errors.roomheight = 'Please enter the room height.';
            return false;
        }
        let valid = store.user.room.height !== '' && store.user.room.height !== 0;
        if (!valid) {
            store.validation.Room.errors.roomheight = 'Please enter the room height.';
        } else {
            store.validation.Room.errors.roomheight = '';
        }
        return valid;
    },

    //
    // Validate the room usage field
    //
    validateRoomUsage(store) {
        // Return false (invalid) if room is null/undefined to prevent errors
        if (!store.user.room) {
            store.validation.Room.errors.roomusage = 'Please select the room usage.';
            return false;
        }
        if (!store.user.room.usage) {
            store.user.room.usage = '';
        }
        let valid = store.user.room.usage !== '';
        if (!valid) {
            store.validation.Room.errors.roomusage = 'Please select the room usage.';
        } else {
            store.validation.Room.errors.roomusage = '';
        }
        return valid;
    },

    //
    // Validate the room materials field
    //
    validateRoomMaterials(store) {
        let valid = true;
        // let valid = store.user.room.materials !== '' && store.user.room.materials.length !== 0;
        // if (!valid) {
        //     store.validation.Room.errors.roommaterials = 'Please select the room materials.';
        // } else {
        //     store.validation.Room.errors.roommaterials = '';
        // }
        return valid;
    },

    //
    // Validate the product selection
    //
    validateProductSelected(store) {
        const currentProduct = store.currentProduct;
        const valid = currentProduct && currentProduct.product != null && currentProduct.product !== '';
        if (!valid) {
            store.validation.Product.errors.product = 'Please select a product.';
        } else {
            store.validation.Product.errors.product = '';
        }
        return valid;
    },

    //
    // Validate the product shape selection (for products with shape variants like Tessell)
    // Returns true if: product has no shapes, OR product has shapes AND one is selected.
    //
    validateProductShape(store) {
        const currentProduct = store.currentProduct;

        // Return true if currentProduct is null/undefined (other validations will catch this)
        if (!currentProduct) {
            return true;
        }

        // Check if product has shape variants
        const hasShapes = currentProduct.data?.hasShapes === true;

        // If no shapes, validation passes
        if (!hasShapes) {
            store.validation.Product.errors.productshape = '';
            return true;
        }

        // Shape variants exist - check if one is selected
        const shape = currentProduct.shape;
        const hasShape = shape != null && typeof shape === 'string' && shape.length > 0;

        if (!hasShape) {
            store.validation.Product.errors.productshape = 'Please select a product shape.';
            return false;
        }

        store.validation.Product.errors.productshape = '';
        return true;
    },

    //
    // Validate the product size selection
    //
    validateProductSize(store) {
        const currentProduct = store.currentProduct;

        // Return false (invalid) if currentProduct is null/undefined to prevent errors
        if (!currentProduct) {
            store.validation.Product.errors.productsize = 'Please select a product size.';
            return false;
        }

        // Check if size exists, is a string, and is not empty
        const size = currentProduct.size;
        const hasSize = size != null && typeof size === 'string' && size.length > 0;

        if (!hasSize) {
            store.validation.Product.errors.productsize = 'Please select a product size.';
            return false;
        }

        // Some products have a size variant (such as height variants for linear products)
        // So we need to validate the user has selected a size variant before continuing.
        const variantsAll = currentProduct.data?.sizes?.variants?.all;
        const hasSizeVariants =
            variantsAll != null && typeof variantsAll === 'object' && !Array.isArray(variantsAll) && Object.keys(variantsAll).length > 0;

        if (hasSizeVariants) {
            const sizeVariant = currentProduct.size_variant;
            const hasVariant = sizeVariant != null && typeof sizeVariant === 'string' && sizeVariant.length > 0;
            if (!hasVariant) {
                store.validation.Product.errors.productsize = 'Please complete all product size selections.';
                return false;
            }
        }

        store.validation.Product.errors.productsize = '';
        return true;
    },

    //
    // Validate the product lumen output selection (for Product step)
    // Returns true if: no lumen options exist, OR lumen options exist AND one is selected.
    //
    validateProductLumenOutput(store) {
        const currentProduct = store.currentProduct;

        // Return true if currentProduct is null/undefined (other validations will catch this)
        if (!currentProduct) {
            return true;
        }

        // Check if product has lumen options (from dataExtended)
        const hasLumenOptions = currentProduct.dataExtended && currentProduct.dataExtended.length > 0;

        // If no lumen options, validation passes
        if (!hasLumenOptions) {
            store.validation.Product.errors.productlumen = '';
            return true;
        }

        // Lumen options exist - check if one is selected
        const hasSelection = currentProduct.selectedLumenOutput && currentProduct.selectedLumenOutput.length > 0;

        if (!hasSelection) {
            store.validation.Product.errors.productlumen = 'Please select a lumen output option.';
            return false;
        }

        store.validation.Product.errors.productlumen = '';
        return true;
    },

    /*
	------------------------------------------------------------------------
	Validation functions for the REPORT step.
	These are used to check if a specific product's lumen output and size variant are valid.
	These are used to check if the report is valid.
	------------------------------------------------------------------------
	*/

    //
    // Check if a product's lumen output is valid.
    // Returns true if: no lumen options exist, OR lumen options exist AND one is selected.
    //
    isProductLumenOutputValid(product) {
        const hasLumenOptions = product.dataExtended && product.dataExtended.length > 0;
        if (!hasLumenOptions) return true; // No lumen options = valid

        const hasSelection = product.selectedLumenOutput && product.selectedLumenOutput.length > 0;
        return hasSelection;
    },

    //
    // Check if a product's shape is valid.
    // Returns true if: no shapes exist, OR shapes exist AND one is selected.
    //
    isProductShapeValid(product) {
        const hasShapes = product.data?.hasShapes === true;
        if (!hasShapes) return true; // No shapes = valid

        const hasShape = product.shape != null && typeof product.shape === 'string' && product.shape.length > 0;
        return hasShape;
    },

    //
    // Check if a product's primary size is valid.
    // Returns true if a size is selected.
    //
    isProductSizeValid(product) {
        const hasSize = product.size != null && typeof product.size === 'string' && product.size.length > 0;
        return hasSize;
    },

    //
    // Check if a product's size variant is valid.
    // Returns true if: no variants exist, OR variants exist AND one is selected.
    //
    isProductSizeVariantValid(product) {
        const variantsAll = product.data?.sizes?.variants?.all;
        const hasSizeVariants =
            variantsAll != null && typeof variantsAll === 'object' && !Array.isArray(variantsAll) && Object.keys(variantsAll).length > 0;

        if (!hasSizeVariants) return true; // No variants = valid

        const hasVariant = product.size_variant != null && typeof product.size_variant === 'string' && product.size_variant.length > 0;
        return hasVariant;
    },

    //
    // Validate the Report step.
    // Returns true if all products pass all validations.
    //
    validateReport(store) {
        if (!store.user.products || store.user.products.length === 0) {
            store.validation.Report.valid = true;
            return true;
        }

        for (const product of store.user.products) {
            // Check each condition - add new checks here as needed
            if (!this.isProductShapeValid(product)) {
                store.validation.Report.valid = false;
                return false;
            }
            if (!this.isProductSizeValid(product)) {
                store.validation.Report.valid = false;
                return false;
            }
            if (!this.isProductSizeVariantValid(product)) {
                store.validation.Report.valid = false;
                return false;
            }
            if (!this.isProductLumenOutputValid(product)) {
                store.validation.Report.valid = false;
                return false;
            }
        }

        store.validation.Report.valid = true;
        return true;
    },
};
